import {
  minutesToHoursMinutes,
  normalizeIdleForDisplay,
} from '@/utils/idleDisplayUtils';

export const calculateStatCardData = (timeData) => {
  const idleHours = timeData?.idleHours ?? 0;
  const idleMinutes = timeData?.idleMinutes ?? 0;
  const hours = timeData?.totalHours ?? 0;
  const minutes = timeData?.totalMinutes ?? 0;

  const totalMinutesAll = hours * 60 + minutes;
  const totalIdleMinutesRaw = idleHours * 60 + idleMinutes;
  const { displayIdle: displayIdleMinutes } = normalizeIdleForDisplay(
    totalMinutesAll,
    totalIdleMinutesRaw
  );
  const displayProductiveMinutes = Math.max(
    0,
    totalMinutesAll - displayIdleMinutes
  );
  const displayIdleHm = minutesToHoursMinutes(displayIdleMinutes);
  const displayProductiveHm = minutesToHoursMinutes(displayProductiveMinutes);

  const productiveScore =
    (displayProductiveMinutes / (totalMinutesAll || 1)) * 100;

  const totalTimeTrackedText = `${hours}h ${minutes}m`;
  const idleTimeText = `${displayIdleHm.hours}h ${displayIdleHm.minutes}m`;
  const productiveTimeText = `${displayProductiveHm.hours}h ${displayProductiveHm.minutes}m`;

  return {
    productiveScore,
    totalTimeTrackedText,
    idleTimeText,
    productiveTimeText,
  };
};
